var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M466 0H286c-24.814 0-46 22.186-46 47v150c0 24.814 21.186 45 46 45h180c24.814 0 46-20.186 46-45V47c0-24.814-21.186-47-46-47zM331 167c0 8.291-6.709 15-15 15s-15-6.709-15-15v-30c0-8.291 6.709-15 15-15s15 6.709 15 15v30zm60 0c0 8.291-6.709 15-15 15s-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60zm60 0c0 8.291-6.709 15-15 15s-15-6.709-15-15V77c0-8.291 6.709-15 15-15s15 6.709 15 15v90zM120 92c-33.091 0-60 26.909-60 60s26.909 60 60 60 60-26.909 60-60-26.909-60-60-60zM172.619 224.684C157.784 235.456 139.697 242 120 242s-37.784-6.544-52.619-17.316c-34.697 17.093-60.227 50.059-66.088 89.678-.817 5.515 1.558 10.499 5.427 13.812C20.127 295.286 52.348 272 90 272c36.91 0 68.632 22.372 82.5 54.232 10.085-23.168 29.745-40.963 53.862-49.129-11.881-22.635-30.712-41.074-53.743-52.419z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 302c-33.091 0-60 26.909-60 60s26.909 60 60 60 60-26.909 60-60-26.909-60-60-60zM255 302c-33.091 0-60 26.909-60 60s26.909 60 60 60 61-26.909 61-60-27.909-60-61-60zM421 302c-33.091 0-60 26.909-60 60s26.909 60 60 60 61-26.909 61-60-27.909-60-61-60zM135 482c0-18.153 4.299-35.224 11.62-50.618C131.105 444.068 111.559 452 90 452c-26.495 0-50.107-11.721-66.592-30C9.016 437.959 0 458.866 0 482v15c0 8.291 6.709 15 15 15h122.763c-1.681-4.715-2.763-9.716-2.763-15v-15zM322.592 422c-16.485 18.279-41.097 30-67.592 30s-50.107-11.721-66.592-30C174.016 437.959 165 458.866 165 482v15c0 8.291 6.709 15 15 15h151c8.291 0 15-6.709 15-15v-15c0-23.134-9.016-44.041-23.408-60zM488.592 422c-16.485 18.279-41.097 30-67.592 30-21.559 0-41.105-7.932-56.62-20.618C371.701 446.776 376 463.847 376 482v15c0 5.284-1.082 10.285-2.763 15H497c8.291 0 15-6.709 15-15v-15c0-23.134-9.016-44.041-23.408-60z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.f9e44e2679f04e155ce002bcc798462b.svg";
export { ForwardRef as ReactComponent };